import { cn } from "@omni/utils/styles";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = { className?: string; innerHTML: string };

export const CashbackModal = ({ className, innerHTML }: Props) => {
    const { t } = useGranite();

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.Cashback}
            title={
                <h2
                    className={cn("tw:text-secondary")}
                    style={{ wordBreak: "break-word" }}
                >
                    <i
                        className={cn("las la-cart-arrow-down")}
                        aria-hidden="true"
                    />
                    {t("product.cashback.modal.title")}
                </h2>
            }
        >
            <div dangerouslySetInnerHTML={{ __html: innerHTML }} />
        </RouterModal>
    );
};
